import type { ConsignmentFeeCalculation } from '@tcvs/shared';
import { formatMoneyMinor as money } from './consignment-ui';
export function ConsignmentFeeBreakdown({
  calculation,
}: {
  calculation?: ConsignmentFeeCalculation;
}) {
  if (!calculation) return null;
  return (
    <details>
      <summary>Fee calculation</summary>
      <p>{calculation.payoutBps / 100}% payout tier · $0 minimum payout</p>
      <table className="tcvs-table">
        <thead>
          <tr>
            <th>Fee</th>
            <th>Scheduled</th>
            <th>Applied</th>
            <th>Waived</th>
          </tr>
        </thead>
        <tbody>
          {(
            [
              ['commissionAmountMinor', 'Commission'],
              ['listingFeeMinor', 'Listing'],
              ['serviceFeeMinor', 'Service'],
            ] as const
          ).map(([key, label]) => (
            <tr key={key}>
              <th>{label}</th>
              <td>{money(calculation.scheduled[key])}</td>
              <td>{money(calculation.applied[key])}</td>
              <td>{money(calculation.waived[key])}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </details>
  );
}
